import api from './api';

const currentAccountService = {
  getAll: async () => {
    const response = await api.get('/current-accounts');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/current-accounts/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/current-accounts', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/current-accounts/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/current-accounts/${id}`);
    return response.data;
  }
};

export default currentAccountService;